"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EntityType;

(function (EntityType) {
  EntityType["SCENE"] = "scene";
  EntityType["PROFILE"] = "profile";
  EntityType["WEARABLE"] = "wearable";
})(EntityType = exports.EntityType || (exports.EntityType = {}));

var EntityVersion;

(function (EntityVersion) {
  EntityVersion["V2"] = "v2";
  EntityVersion["V3"] = "v3";
})(EntityVersion = exports.EntityVersion || (exports.EntityVersion = {}));